import gql from 'graphql-tag';

/**
 * Data of the block project-measurement-report-approval ("Aufmaßprotokoll: Freigabe"): the approval
 * state and the note at its path `measurement.measurementApprovementNote`. Read through
 * `Project.blocks.measurementReportApproval`, which checks the block's read permission.
 */
export const PROJECT_MEASUREMENT_REPORT_APPROVAL_FIELDS = gql`
  fragment projectMeasurementReportApprovalFields on ProjectMeasurementReportApprovalBlock {
    id
    number
    measurementApprovementVerificationState
    measurement {
      measurementApprovementNote
    }
  }
`;
